
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]/reviews",
      function () {
        return require("private-next-pages/[username]/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[username]/reviews"])
      });
    }
  